import PageStyle from "@/styles/components/request-for-more/_index.module.scss";
import Modal from "@/components/common-modal/modal"
;import { useTranslation } from 'react-i18next';

export function RescheduleDetails({meetingId, setBtnPopup, meetingDetails}) {
  const {t} = useTranslation()
  return (
    <Modal
    type="info"
      closeModal={()=> setBtnPopup(false)}
      heading={t('modal:reschedule_details')}
      className={`RequestMore mt20`}
      innerContent={
        <>
          <div className={PageStyle.RequestDetails}>
           <h4>{t('modal:info:reschedule:request')}</h4>

           <h5 className={PageStyle.RequestDetails__gridauto}>{t('label:duration')}: <span>{meetingDetails.details.duration} </span></h5>

        </div>
        </>
      }

      />
  )

}
